import { render } from "./Embassy.vue?vue&type=template&id=efeeb5e4"
import script from "./Embassy.vue?vue&type=script&lang=js"
export * from "./Embassy.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/buildings/Embassy.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "efeeb5e4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('efeeb5e4', __exports__)) {
    api.reload('efeeb5e4', __exports__)
  }
  
  module.hot.accept("./Embassy.vue?vue&type=template&id=efeeb5e4", () => {
    api.rerender('efeeb5e4', render)
  })

}


export default __exports__